import { mattermostApiClient } from '@/services/apiClient';
import { isTokenExpired } from '@/services/gcauth.service';

export function shouldRefreshAuthToken(): boolean {
  const authToken = mattermostApiClient.authToken;
  const isJwt = mattermostApiClient.isJwtAuth;
  const tokenExpired = isJwt ? isTokenExpired(authToken) : false;
  return !authToken || (isJwt && tokenExpired);
}

export function getAuthTokenStatus(): { hasToken: boolean; isJwt: boolean; tokenExpired: boolean } {
  const authToken = mattermostApiClient.authToken;
  const isJwt = mattermostApiClient.isJwtAuth;
  const tokenExpired = isJwt ? isTokenExpired(authToken) : false;
  return {
    hasToken: !!authToken,
    isJwt,
    tokenExpired
  };
}
